import axios from 'axios';
import { USER_STORAGE_USER_KEY } from '../sagas/login/utils';
import Cookies from 'universal-cookie';

export const loginRequest = (s: string) =>
  axios.post(`/v1/access_tokens`, null, {
    headers: { Authorization: `Basic ${s}` },
  });

export const autoLoginRequest = (token: string) =>
  axios.post(`/v1/login/otp`, null, {
    data: {
      token: token,
    },
  });

export const getAutoLoginToken = () => {
  return axios.post('/v1/sso/otps');
};

export const signupRequest = (
  email: string,
  password: string,
  visitorID: string | undefined = '',
) => {
  const data: any = {
    email,
    password,
    confirmed_password: password,
    terms_accepted: true,
  };
  const cookies = new Cookies();
  const areCookiesAccepted = Boolean(cookies.get('cookies_accepted'));

  if (areCookiesAccepted && visitorID) data.visitor_id = visitorID;

  return axios.post(`/v1/users`, null, {
    data,
  });
};

export const fbLoginRequest = (token: string) =>
  axios.post(`/v1/users/facebook`, null, {
    data: {
      token: token,
    },
  });
export const appleLoginRequest = (
  token: string,
  email?: string,
  username?: string,
) => {
  if (email && username) {
    return axios.post(`/v1/users/apple`, null, {
      data: {
        token: token,
        username: username,
        email: email,
      },
    });
  } else {
    return axios.post(`/v1/users/apple`, null, {
      data: {
        token: token,
      },
    });
  }
};

export const logoutRequest = () => {
  axios.delete(`/v1/access_tokens`);
  window.localStorage.removeItem(USER_STORAGE_USER_KEY);
  return;
};
